import { BaseController } from "./../../modules/base/base.controller";
import fileUploadController, {
  FileUploadController,
} from "../../modules/file-upload/file-upload.controller";

export { fileUploadController, FileUploadController, BaseController };
